module.exports = __webpack_public_path__ + "img/titlezh.f5f8e081.png";